import { filterTypographyProps, getTypographyStyles } from './utils';
import { type ForwardedRef, forwardRef } from 'react';
import { Heading as ReactAriaHeading, HeadingProps } from 'react-aria-components';
import { mergeProps } from 'react-aria';

import { type HtmlPropsWithoutClassNameAndStyle, type TypographyProps } from './types';
import { TextContent } from './TextContent';

type Level = 1 | 2 | 3 | 4 | 5 | 6;
type HeadingTag = `h${Level}`;
export type Props = HtmlPropsWithoutClassNameAndStyle<
  HeadingTag,
  TypographyProps & { level: Level } & Pick<HeadingProps, 'slot'>
>;

export const Heading = forwardRef(function _Heading(props: Props, ref: ForwardedRef<HTMLHeadingElement>) {
  const { typographyProps, restProps } = filterTypographyProps(props);
  const { truncate, ...restTypographyProps } = typographyProps;
  const { children, ...rest } = restProps;
  const styles = getTypographyStyles(restTypographyProps);

  return (
    <ReactAriaHeading {...mergeProps(rest, { className: styles })} ref={ref}>
      <TextContent truncate={truncate}>{children}</TextContent>
    </ReactAriaHeading>
  );
});
